import React from 'react';
import Routes from "./Routes";

class App extends React.Component {

  render(){
	  return (
	      <Routes />
	  );
  }
}

export default App;
